import { Component, Input, Type } from '@angular/core';

@Component({
  selector: 'app-modal-reactive',
  templateUrl: './modal-reactive.component.html',
  styleUrl: './modal-reactive.component.scss',
})
export class ModalReactiveComponent {
  @Input() title = '';
  @Input() contentType: 'text' | 'list' | 'table' | 'image' | 'component' =
    'text';
  @Input() content: unknown;
  @Input() dynamicComponent!: Type<unknown>;
  @Input() sizeModal: 'sm' | 'lg' | 'xl' = 'lg';

  closeModal() {
    // Acceder a bootstrap desde el objeto global
    const modalElement = document.getElementById(
      this.generateModalId(this.title)
    );
    if (modalElement) {
      // Accede al objeto bootstrap desde el window global
      const bootstrapModal = (window as any).bootstrap;
      if (bootstrapModal) {
        const modalInstance = bootstrapModal.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide(); // Cierra el modal
        }
      }
    }
  }

  generateModalId(title: string): string {
    return title
      .toLowerCase() // Convierte todo a minúsculas
      .replace(/\s+/g, '_') // Reemplaza los espacios por guiones bajos
      .replace(/[^\w]/g, ''); // Elimina todos los caracteres que no son alfanuméricos
  }
}
